import { render, staticRenderFns } from "./DomainSwitcher.vue?vue&type=template&id=72a1f518&scoped=true"
import script from "./DomainSwitcher.vue?vue&type=script&lang=js"
export * from "./DomainSwitcher.vue?vue&type=script&lang=js"
import style0 from "./DomainSwitcher.vue?vue&type=style&index=0&id=72a1f518&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1f518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a1f518')) {
      api.createRecord('72a1f518', component.options)
    } else {
      api.reload('72a1f518', component.options)
    }
    module.hot.accept("./DomainSwitcher.vue?vue&type=template&id=72a1f518&scoped=true", function () {
      api.rerender('72a1f518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Utility/DomainSwitcher.vue"
export default component.exports